const observedThresholds = Array.from({ length: 21 }).fill(0).map((_, idx) => +(idx * 0.05).toFixed(2));
export {
  observedThresholds
};
//# sourceMappingURL=observedThresholds.js.map
